export default "__VITE_ASSET__271a75e5__"